import React, { useEffect, useState } from 'react';
import { usePromise } from "@randajan/jet-react";
import Slider from "react-slick";

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import "./Reference.scss";
import ArrowLeft from "./arrow_left.svg";
import ArrowRight from "./arrow_right.svg";

import { apiGet } from "../../components/tools";

const SLICK_SETTINGS = {
  arrows: true,
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <img src={ArrowRight}/>,
  prevArrow: <img src={ArrowLeft}/>
};

function Reference () {

  const [ reference, refresh ] = usePromise([], async _=>{
    const refs = await apiGet("care_reviews");
    for (const ref of refs) { ref.writed_at = new Date(ref.writed_at); }
    return refs.sort((a,b)=>b.writed_at-a.writed_at);
  });


  return (
    <section className="Reference glass dark">
      <Slider.default {...SLICK_SETTINGS}>
        {Array.jet.to(reference).map((ref, key) => 
          <div key={key} className="reference">
            <div className="block">
              <div>
                <p className="quote">{ref.text}</p>
                <p className="sign">{ref.sign}</p>
              </div>
            </div>
          </div>
        )}
      </Slider.default>
    </section>
  );
}

export default Reference;
